function AutocompleterInputCtrl() {}
;
export default AutocompleterInputCtrl;